import React from 'react';
import { SkHeader, SkStatCards, SkChartCard, SkTable } from './_primitives';

/** ShareLinkPage — 4 stats, bar chart + funnel chart, 2 tables (source, referrers) */
const ShareLinkPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={1} />
    <SkStatCards count={4} />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
      <SkChartCard height={320} />
      <SkChartCard height={320} />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <SkTable rows={6} cols={4} />
      <SkTable rows={6} cols={5} />
    </div>
  </div>
);

export default ShareLinkPageLoader;
